import React from "react";
import { makeStyles, SvgIcon } from "@material-ui/core";

const useStyle = makeStyles({
  root: {
    fontSize: "20px",
  },
});

export function AnalyticsIcon() {
  const classes = useStyle();

  return (
    <SvgIcon classes={classes} viewBox="0 0 20 20">
      <path d="M2.50033 2.5H17.5003C17.7213 2.5 17.9333 2.5878 18.0896 2.74408C18.2459 2.90036 18.3337 3.11232 18.3337 3.33333V16.6667C18.3337 16.8877 18.2459 17.0996 18.0896 17.2559C17.9333 17.4122 17.7213 17.5 17.5003 17.5H2.50033C2.27931 17.5 2.06735 17.4122 1.91107 17.2559C1.75479 17.0996 1.66699 16.8877 1.66699 16.6667V3.33333C1.66699 3.11232 1.75479 2.90036 1.91107 2.74408C2.06735 2.5878 2.27931 2.5 2.50033 2.5ZM3.33366 4.16667V15.8333H16.667V4.16667H3.33366ZM5.83366 10.8333H7.50033V14.1667H5.83366V10.8333ZM9.16699 5.83333H10.8337V14.1667H9.16699V5.83333ZM12.5003 8.33333H14.167V14.1667H12.5003V8.33333Z" />
    </SvgIcon>
  );
}
